export default "__VITE_ASSET__BVcKlMe9__"